import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/core';

import { ICustomTheme } from 'interfaces';

export const Content = styled.div<{ theme: ICustomTheme }>(({ theme }) => ({
  backgroundColor: theme.colors.white,
  display: 'flex',
  flexBasis: 655,
  flexDirection: 'column',
  height: '100vh',
  maxWidth: '100%',
  overflow: 'auto',
  padding: theme.spacing(5, 10),
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(3),
  },
}));

export const ContentWrapper = styled.div<{ theme: ICustomTheme }>(
  ({ theme }) => ({
    margin: `auto 0 ${theme.spacing(5)}px 0`,
  }),
);

export const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'row-reverse',
  height: '100vh',
});

export const Brand = styled.div({
  display: 'flex',
  justifyContent: 'center',
});

export const Illustration = styled.div({
  flex: 1,
});

export const cssIllustration = css({
  height: '100%',
  objectFit: 'cover',
  width: '100%',
});

export const cssLogo = (theme: ICustomTheme): SerializedStyles =>
  css({
    alignSelf: 'center',
    marginBottom: theme.spacing(3),
    maxHeight: '15rem',
    maxWidth: 260,
    width: `calc(100vw - ${theme.spacing(4)}px)`,
  });
